export default __webpack_public_path__ + "static/fantasy_1-e95cba578d5425dafba0f7b230468038.png";